import React, { ErrorInfo } from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { ReloadOutlined, HomeOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

interface Props {
  error: Error | null;
  errorInfo: ErrorInfo | null;
  onReset: () => void;
}

declare let process: any;

const ErrorFallback: React.FC<Props> = ({ error, errorInfo, onReset }) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <div style={{ padding: '50px', textAlign: 'center', minHeight: '400px' }}>
      <Result
        status="error"
        title="Something went wrong"
        subTitle="We're sorry, but the inbox encountered an error. Please try reloading or contact support if the problem persists."
        extra={
          <Space>
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={onReset}
              size="large"
            >
              Reload Inbox
            </Button>
            <Button
              icon={<HomeOutlined />}
              onClick={() => (window.location.href = '/')}
              size="large"
            >
              Go Home
            </Button>
          </Space>
        }
      >
        {isDevelopment && error && (
          <div style={{ marginTop: '20px' }}>
            <Paragraph>
              <Text
                strong
                style={{
                  fontSize: 16,
                  color: '#ff4d4f',
                }}
              >
                Error Details (Development Only):
              </Text>
            </Paragraph>
            <div
              style={{
                textAlign: 'left',
                background: '#f5f5f5',
                padding: '15px',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
                maxWidth: '800px',
                margin: '0 auto',
              }}
            >
              <Text strong>Error:</Text>
              <pre style={{ marginTop: '8px', fontSize: '12px', color: '#d32f2f' }}>
                {error.toString()}
              </pre>
              
              {error.stack && (
                <>
                  <Text strong style={{ marginTop: '12px', display: 'block' }}>
                    Stack Trace:
                  </Text>
                  <pre
                    style={{
                      marginTop: '8px',
                      fontSize: '11px',
                      maxHeight: '200px',
                      overflow: 'auto',
                      color: '#666',
                    }}
                  >
                    {error.stack}
                  </pre>
                </>
              )}

              {errorInfo && errorInfo.componentStack && (
                <>
                  <Text strong style={{ marginTop: '12px', display: 'block' }}>
                    Component Stack:
                  </Text>
                  <pre
                    style={{
                      marginTop: '8px',
                      fontSize: '11px',
                      maxHeight: '150px',
                      overflow: 'auto',
                      color: '#666',
                    }}
                  >
                    {errorInfo.componentStack}
                  </pre>
                </>
              )}
            </div>
          </div>
        )}
      </Result>
    </div>
  );
};

export default ErrorFallback;
